import { Quote } from "../../../../api/Quote/Quote";
import { FeatureDiscount } from "../../../../app/consts";
import { useConfig } from "../../../../components/config/ConfigContext";
import { DeductionLine } from "./DeductionLine";

interface Props {
  quote: Quote;
  onDelete: (quoteDeductionId: string, promoCode: string | null) => Promise<void>;
  hasRemoveButton: boolean;
}

export const DeductionLines = ({ quote, onDelete, hasRemoveButton }: Props) => {
  const { isFeatureEnabled } = useConfig();

  if (!isFeatureEnabled(FeatureDiscount)) {
    return <></>;
  }

  return (
    <>
      {quote.deductions.map((item, i) => (
        <DeductionLine key={i} deduction={item} onDelete={onDelete} hasRemoveButton={hasRemoveButton} />
      ))}
    </>
  );
};
